import React from "react";
import { Link } from "react-router-dom";
import { PageHero } from "./AboutPage";
import { CalendarX } from "lucide-react";

const EventsPage = () => {
  return (
    <div>
      <PageHero
        overline="Events"
        title="Calendar of the Brotherhood."
        subtitle="Open programming, formals, and service engagements throughout the academic year."
      />

      <section className="section-pad">
        <div className="max-w-3xl mx-auto px-5" data-testid="events-empty">
          <div className="bg-white border border-[#D8D3C4] p-12 md:p-16 text-center">
            <div className="mx-auto w-14 h-14 flex items-center justify-center border border-[#D4AF37] text-[#D4AF37] mb-6">
              <CalendarX size={24} />
            </div>
            <div className="overline text-[#C9A227] mb-3">No Upcoming Events</div>
            <h2 className="font-serif-display text-4xl text-[#0A1F44]">
              There are no events scheduled right now.
            </h2>
            <p className="mt-5 text-[#5C5C5C] leading-relaxed">
              Check back soon &mdash; our next round of programming, formals, and
              service engagements will be posted here as they are confirmed.
            </p>
            <div className="mt-8">
              <Link to="/contact" className="btn-primary-navy" data-testid="events-contact-cta">
                Stay in the Loop
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventsPage;
